import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DesignEditorPrimaryControlButton from '../../../../../../../components/global/DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';
import { DesignEditorPrimaryControls } from '../../../../../../../components/global/DesignEditor/components/DesignEditorControls';
import SizingIcon from '../../../../../../../components/icons/SizingIcon';
import MountingIcon from '../../../../../../../components/icons/MountingIcon';
import TemplatesIcon from '../../../../../../../components/icons/TemplatesIcon';

const propTypes = {
  className: PropTypes.string,
  activeControl: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export const PRINT_PRODUCT_CONFIGURATOR_PRIMARY_CONTROL = {
  SIZE: 'SIZE',
  MOUNTING: 'MOUNTING',
  CARD_SIDES: 'CARD_SIDES',
};

const PrimaryControlsPane = ({
  className,
  activeControl,
  onClick,
  supportsMounts,
  supportsCardSides,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControls className={classes}>
      <DesignEditorPrimaryControlButton
        active={
          activeControl === PRINT_PRODUCT_CONFIGURATOR_PRIMARY_CONTROL.SIZE
        }
        icon={<SizingIcon />}
        title="Size"
        onClick={() => {
          onClick(PRINT_PRODUCT_CONFIGURATOR_PRIMARY_CONTROL.SIZE);
        }}
      />

      {supportsMounts && (
        <DesignEditorPrimaryControlButton
          active={
            activeControl ===
            PRINT_PRODUCT_CONFIGURATOR_PRIMARY_CONTROL.MOUNTING
          }
          icon={<MountingIcon />}
          title="Mounting"
          onClick={() => {
            onClick(PRINT_PRODUCT_CONFIGURATOR_PRIMARY_CONTROL.MOUNTING);
          }}
        />
      )}

      {supportsCardSides && (
        <DesignEditorPrimaryControlButton
          active={
            activeControl ===
            PRINT_PRODUCT_CONFIGURATOR_PRIMARY_CONTROL.CARD_SIDES
          }
          icon={<TemplatesIcon />}
          title="Templates"
          onClick={() => {
            onClick(PRINT_PRODUCT_CONFIGURATOR_PRIMARY_CONTROL.CARD_SIDES);
          }}
        />
      )}
    </DesignEditorPrimaryControls>
  );
};

PrimaryControlsPane.propTypes = propTypes;

export default PrimaryControlsPane;
